import { observer } from "mobx-react-lite"
import { useProposalsEditDetailsStore } from "./ProposalsEditDetailsStore"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import { notNull } from "@gap/utils/utils"
import GapButtonTooltip from "features/gap-components/tooltip/GapButtonTooltip"
import Stack from "@mui/material/Stack"
import GapAutocompleteMultiple from "features/gap-components/autocomplete/multiple/GapAutocompleteMultiple"

export default observer(function ProposalsEditDetailsObjectivesAndValue() {
   const proposalsEditDetailsStore = useProposalsEditDetailsStore()

   return <>
      <Typography variant="subtitle1">Highlight the Objectives & Value</Typography>
      <Typography variant="caption">Highlight the objectives of working together and the main value your client will receive. 3-6 is a good number to aim for.</Typography>

      <Box sx={{ pt: 2, pb: 1, fontWeight: 'bold', textAlign: 'right' }}>
         <GapButtonTooltip buttonText='Need help choosing Objectives & Value?' tooltip={<ProposalsEditDetailsObjectivesAndValueTooltip />} />
      </Box>
      {proposalsEditDetailsStore.objectivesAndValueOptions ? (
         proposalsEditDetailsStore.formHandler.objectivesAndValue.bindInput(ip => (
            <GapAutocompleteMultiple
               {...ip}
               options={notNull(proposalsEditDetailsStore.objectivesAndValueOptions)}
               disableCloseOnSelect
               label="Choose 3-6 Objectives & Value statements"
            />
         ))
      ) : null}
   </>
})

const ProposalsEditDetailsObjectivesAndValueTooltip = () => (
   <Stack spacing={2}>
      <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
         Choosing Objectives & Value
      </Typography>
      <Typography variant="body2">
         Select 3-6 statements to summarise your client’s objectives and the value to be gained from the engagement.
      </Typography>
      <Typography variant="body2">
         For example, if your proposal includes compliance and advisory services, select statements that reflect this.
      </Typography>
   </Stack>
)

